module.exports = __webpack_public_path__ + "static/media/confirmation-montage.164eb7e7.svg";